export const COOKIE_CONSTANTS = {
  COOKIE_NAME: 'cookieConsent',
  ACCEPT_BUTTON_TEXT: 'Allow Cookies',
  DECLINE_BUTTON_TEXT: 'Decline',
  EXPIRES: 0,
  MESSAGE: 'This website uses cookies to enhance your browsing experience.',
  GRANTED: 'granted',
  DENIED: 'denied',
};